/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BasicFeeHandler,
  BasicFeeHandlerInterface,
} from "../BasicFeeHandler";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "feeHandlerRouterAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "IncorrectFeeSupplied",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "FeeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "FeeCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "FeeDistributed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_domainResourceIDToFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_feeHandlerRouterAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getRoleMemberIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feeHandlerType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "renounceAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "depositData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "collectFee",
    outputs: [],
    stateMutability: "payable",
    type: "function",
    payable: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "depositData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "calculateFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "changeFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "transferFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type BasicFeeHandlerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BasicFeeHandlerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BasicFeeHandler__factory extends ContractFactory {
  constructor(...args: BasicFeeHandlerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "BasicFeeHandler";
  }

  deploy(
    bridgeAddress: string,
    feeHandlerRouterAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BasicFeeHandler> {
    return super.deploy(
      bridgeAddress,
      feeHandlerRouterAddress,
      overrides || {}
    ) as Promise<BasicFeeHandler>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    feeHandlerRouterAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      bridgeAddress,
      feeHandlerRouterAddress,
      overrides || {}
    );
  }
  attach(address: string): BasicFeeHandler {
    return super.attach(address) as BasicFeeHandler;
  }
  connect(signer: Signer): BasicFeeHandler__factory {
    return super.connect(signer) as BasicFeeHandler__factory;
  }
  static readonly contractName: "BasicFeeHandler";
  public readonly contractName: "BasicFeeHandler";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BasicFeeHandlerInterface {
    return new utils.Interface(_abi) as BasicFeeHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BasicFeeHandler {
    return new Contract(address, _abi, signerOrProvider) as BasicFeeHandler;
  }
}
